<template>
  <div class="wt2-collapse">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      activeNames: [].concat(this.value),
    };
  },

  provide() {
    return {
      collapse: this,
    };
  },

  watch: {
    value(value) {
      this.activeNames = [].concat(value);
    },
  },

  methods: {
    setActiveNames(activeNames) {
      activeNames = [].concat(activeNames);
      const value = this.accordion ? activeNames[0] : activeNames;
      this.activeNames = activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    },

    handleItemClick(item) {
      const activeNames = this.activeNames.slice(0);
      const activeItemIndex = activeNames.indexOf(item.name);

      if (this.accordion) {
        this.setActiveNames(
          (this.activeNames[0] || this.activeNames[0] === 0) &&
            this.activeNames[0] === item.name
            ? ''
            : item.name
        );
      } else {
        if (activeItemIndex > -1) {
          activeNames.splice(activeItemIndex, 1);
        } else {
          activeNames.push(item.name);
        }
        this.setActiveNames(activeNames);
      }

      const emitValue = {
        item,
        isActive: activeItemIndex < 0,
        activeNames,
      };

      this.$emit('itemClicked', emitValue);
    },
  },

  created() {
    this.$on('item-click', this.handleItemClick);
  },
};
</script>
